import { decl } from '@yandex-lego/i-bem-react';

export default decl({
    block: 'search2',
    elem: 'hidden',
    tag: 'input',
    attrs: function attrs(_ref) {
        var value = _ref.value,
            name = _ref.name;

        return { type: 'hidden', value: value, name: name };
    }
});